<template>
    <b-card>
        <b-card-body>
            <h4 class="mb-4">Send E-Mail to Registrants</h4>

            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Send To <span class="required">*</span></label>
                        <b-form-select v-model="comm.send">
                            <option value="all">All Registrants</option>
                            <option value="complete">Completed Registrants</option>
                            <option value="pending">Pending Registrants</option>
                            <option value="cc">Registrants Paid By Credit Card</option>
                            <option value="po">Registrants Paid By Purchase Order (P.O.)</option>
                            <option :value="'fee_'  + fee.id" v-for="fee in conference.fees">Registration Fee/Type: {{fee.title}}</option>
                            <option :value="'sess_'  + sess.id" v-for="sess in conference.sessions">Attending {{sess.title}}</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Subject <span class="required">*</span></label>
                        <b-form-input v-model="comm.subject"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <quill-editor v-model="comm.body" ref="myQuillEditor" :options="editorOption"/>
                </b-col>
            </b-form-row>

            <div class="mt-5">
                <b-button variant="success" @click="sendEmail()" :disabled="processing || !comm.subject || !comm.body"><i class="fas fa-envelope mr-3"></i>Send E-Mail</b-button>
                <div class="mt-3" v-if="processing"><i class="fas fa-cog fa-spin mr-3"></i>Sending E-Mails, Please wait...</div>
            </div>

        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "Communicate",
        props: ['id'],
        data: function() {
            return {
                comm: {
                    send: 'all'
                },
                editorOption: {
                    // some quill options
                },
                processing: false
            }
        },
        methods: {
            ...mapActions(['getConferenceById','sendConferenceEmail']),

            sendEmail() {
                this.processing = true;
                this.sendConferenceEmail({id: this.id, data: this.comm}).then(() => {
                    this.processing = false;
                    this.$notify('success', 'E-mails Sent', 'E-mails sent.', {duration: 5000, permanent: false});
                    this.comm = {
                        send: 'all'
                    };
                });
            }
        },
        computed: {
            ...mapGetters(['conference'])
        }
    }
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .quill-editor {
        .ql-toolbar {
            border: 1px solid #e5e5e5;
            border-top-left-radius: 0.2rem;
            border-top-right-radius: 0.2rem;
        }

        .ql-container {
            border: 1px solid #e5e5e5;
            border-bottom-left-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;

            max-height: 400px;
            overflow-y: auto;
        }

        p {
            margin-bottom: 1rem;
        }
    }

    .required {
        color: red;
    }
</style>
